export default __webpack_public_path__ + "static/media/demon.debb2eab.png";